import axios from "axios";
import { usePortalPanel } from "components/navigation/portalPanel";
import { useCallback, useEffect } from "react";
import useSWRImmutable from "swr/immutable";
import { useKnowledgeStore } from "./store";
import { parsePostfix, parseUrl } from "./utils";

export function useKnowledgeUrl() {
  const urls = useKnowledgeStore((state) => state.urls);
  return urls.at(-1)?.split("#")[0];
}

export function useKnowledgeArticle(url: string) {
  useEffect(() => {
    useKnowledgeStore.setState({
      pendingUrl: url,
    });

    return () => {
      useKnowledgeStore.setState((state) => ({
        pendingUrl: state.pendingUrl === url ? undefined : state.pendingUrl,
      }));
    };
  }, [url]);
}

export function useMarkdown(url?: string) {
  let markdownUrl: string | undefined;

  if (url?.endsWith(".md")) {
    markdownUrl = parseUrl(url);
  } else if (url) {
    markdownUrl = parsePostfix(url, "index.md");
  }

  return useSWRImmutable(markdownUrl, (url) =>
    axios.get<string>(url).then((data) => data.data),
  );
}

export function useToggleKnowledge() {
  const { toggle } = usePortalPanel();

  return useCallback(
    (url: string) => {
      useKnowledgeStore.getState().push(url);
      toggle((state) => (state !== "kb" ? "kb" : state));
    },
    [toggle],
  );
}
